import { z } from 'zod';
import { Config } from 'final-form';

import { MessagingCampaignConfigureFormSchema } from './configure-form.schema';

export type MessagingCampaignConfigureFormValues = z.infer<
  typeof MessagingCampaignConfigureFormSchema
>;
export { MessagingCampaignConfigureFormSchema };

export const validateConfigureSync = (values: Partial<MessagingCampaignConfigureFormValues>) =>
  MessagingCampaignConfigureFormSchema.safeParse(values);

export type MessagingCampaignConfigureFormProps = {
  onSubmit: Config<MessagingCampaignConfigureFormValues>['onSubmit'];
  onNextStepClick?: () => void;
  initialValues?: Partial<MessagingCampaignConfigureFormValues>;
  onCancelClick: (hasUnsavedChanges?: boolean) => void;
  loading: boolean;
  isUserPermittedToEdit: boolean;
};
